import { UIIcon } from '@dropbox/dig-icons';
import { ChevronLeftLine } from '@dropbox/dig-icons/assets';
import React from 'react';
import { useIntl } from 'react-intl';
import {
  useSignatureRequestContext,
  useFieldsContext,
} from 'signer-app/signature-request/context';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';
import { useSignerContext } from './signer-experience';
import messages from 'signer-app/signer-experience/signer-toolbar/messages';
import {
  IconButton,
  IconButtonProps,
  IconButtonVariant,
} from '@dropbox/dig-components/buttons';

export function PreviousButton({
  variant = 'opacity',
  size,
}: {
  variant?: IconButtonVariant;
  size?: IconButtonProps['size'];
}) {
  const intl = useIntl();
  const { selectedFieldIds } = useSignatureRequestContext();
  const { selectField } = useSignerContext();
  const fields = useFieldsContext();
  const [activeField] = selectedFieldIds;
  const currentFieldIndex = fields.findIndex((f) => f.id === activeField);

  function handlePrevious() {
    if (!activeField) {
      const field = fields[0];
      selectField(field.id);
    } else {
      const prevIndex =
        currentFieldIndex === 0 ? fields.length - 1 : currentFieldIndex - 1;
      const field = fields[prevIndex];
      selectField(field.id);
    }
  }

  // Only show this button if there is a previous field to navigate to
  if (currentFieldIndex === 0) {
    return null;
  }

  return (
    <WhiteLabelThemeProvider mode="bright">
      <IconButton
        size={size}
        variant={variant}
        onClick={handlePrevious}
        aria-label={intl.formatMessage(messages.prevButton)}
      >
        <UIIcon src={ChevronLeftLine} />
      </IconButton>
    </WhiteLabelThemeProvider>
  );
}
